@if (_toonSnapnorm()) {
    <div class="dl-canvasknoppen__knop"
         [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SNAPNORM' | translate)"
         dlBeginnersuitleg="snapnormbtn"
         (click)="snapnorm.emit()">
        <span class="icon fa-solid fa-bolt"></span>
    </div>
}
@if (_toonNicestates()) {
    <div class="dl-canvasknoppen__knop"
         [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('NICESTATES' | translate)"
         dlBeginnersuitleg="nicestates"
         (click)="niceStates.emit()">
        <span class="icon fa-solid fa-maximize"></span>
    </div>
}
@if (_toonSnapstates()) {
    <div class="dl-canvasknoppen__knop"
         [title]="weergaveInstellingen.beginnersmodusAan() ? '' : ('SNAPSTATES' | translate)"
         dlBeginnersuitleg="snapstates"
         (click)="snapStates.emit()">
        <span class="icon fa-solid fa-bolt"></span>
    </div>
}
<dl-panzoom [view]="_view()" [minZoom]="_minZoom()" [maxZoom]="_maxZoom()"></dl-panzoom>
